const dialog = document.querySelector("dialog");
const showButton = document.querySelector("dialog + button");
const closeButton = document.getElementById("close-price-modal")
const modal = document.getElementById("price-modal")

// "Show the dialog" button opens the dialog modally
showButton.addEventListener("click", () => {
  dialog.showModal();
});

// "Close" button closes the dialog
closeButton.addEventListener("click", () => {
  dialog.close();
});

dialog.addEventListener("click", () => {
  dialog.close();
});

modal.addEventListener('click', (event) => event.stopPropagation());
